class Config {
  helpUrl: string = './help';
  apiKey: string = '';
  apiKeyValue: string = '';
  baseReportingUrl: string = '';

  constructor() {
    let request = new XMLHttpRequest();
    request.open("GET", "./config/config.json", false);
    request.send(null);
    let jsonObject = JSON.parse(request.responseText);

    this.helpUrl = jsonObject.helpUrl || '';
    this.apiKey = jsonObject.apiKey || '';
    this.apiKeyValue = jsonObject.apiValue || '';
    this.baseReportingUrl = jsonObject.baseReportingUrl || '';

  }
}

export default new Config();



// WEBPACK FOOTER //
// src/config.ts